import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=d1aca500&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1aca500')) {
      api.createRecord('d1aca500', component.options)
    } else {
      api.reload('d1aca500', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=d1aca500&", function () {
      api.rerender('d1aca500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22I4Ey5vyGV0W/JS/pricehelp.vue"
export default component.exports